import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=f4b950fa&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=f4b950fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b950fa",
  null
  
)

export default component.exports